<span [innerHTML]="htmlComunicado"></span>